webpackJsonp([92115451398090],{

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sean_lawrence_resume_web_developer.4b363df3.pdf";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageWrapperSlim = __webpack_require__(19);
	
	var _PageWrapperSlim2 = _interopRequireDefault(_PageWrapperSlim);
	
	var _logo = __webpack_require__(31);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _sean_lawrence_resume_web_developer = __webpack_require__(322);
	
	var _sean_lawrence_resume_web_developer2 = _interopRequireDefault(_sean_lawrence_resume_web_developer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var html = data.markdownRemark.html;
	
	  return _react2.default.createElement(
	    _PageWrapperSlim2.default,
	    {
	      title: 'Resume',
	      id: 'resume',
	      description: 'A resume for Sean Lawrence, a modern web developer based out of Chicago, IL.',
	      image: _logo2.default,
	      imageDescription: 'Profile image for Sean Lawrence',
	      metaDate: '2017-12-11',
	      url: 'https://seanlawrence.co/resume'
	    },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Download ',
	      _react2.default.createElement(
	        'a',
	        { href: _sean_lawrence_resume_web_developer2.default },
	        'PDF version'
	      ),
	      '.'
	    ),
	    _react2.default.createElement('section', {
	      dangerouslySetInnerHTML: { __html: html }
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-resume-js-57c5aea4c51ab105258d.js